import {NgModule} from '@angular/core';
import {LoginComponent} from './login_form/login.component';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {LoginRoutes} from './login.routing';
import {SharedModule} from '../../shared/shared.module';
import { LoadingModule } from 'ngx-loading';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {MatButtonModule, MatCheckboxModule,MatDatepickerModule,MatFormFieldModule,MatSliderModule,MatCardModule,MatDividerModule,MatExpansionModule,MatGridListModule,MatChipsModule,MatProgressBarModule,MatDialogModule,MatSnackBarModule,MatTooltipModule,MatSortModule,MatTableModule,
    MatMenuModule,MatSidenavModule,MatToolbarModule,MatNativeDateModule, MatInputModule,MatRadioModule,MatListModule,MatStepperModule,MatButtonToggleModule,MatTabsModule,MatSelectModule,MatIconModule,MatProgressSpinnerModule,MatPaginatorModule,MatAutocompleteModule} from '@angular/material';
import { HttpClient } from '@angular/common/http';
import {  RecaptchaModule} from 'ng-recaptcha';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha'; 
@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(LoginRoutes),
        SharedModule,
        LoadingModule,
        MatButtonModule, MatCheckboxModule,MatDatepickerModule,MatFormFieldModule,MatSliderModule,MatCardModule,MatDividerModule,MatExpansionModule,MatGridListModule,MatChipsModule,MatProgressBarModule,MatDialogModule,MatSnackBarModule,MatTooltipModule,MatSortModule,MatTableModule,
        MatMenuModule,MatSidenavModule,MatToolbarModule,MatNativeDateModule, MatInputModule,MatRadioModule,MatListModule,MatStepperModule,MatButtonToggleModule,MatTabsModule,MatSelectModule,MatIconModule,MatProgressSpinnerModule,MatPaginatorModule,MatAutocompleteModule,RecaptchaModule,
        RecaptchaV3Module,
        TranslateModule.forChild({
            loader: {
              provide: TranslateLoader,
              useFactory: (http: HttpClient) => (new TranslateHttpLoader(http, './assets/i18n/', '.json')),
              deps: [HttpClient]
            }
          }),
    ],
    declarations: [LoginComponent],
    providers:[
      { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LeULvIqAAAAANxlrjUS9rczzpS0aqfrFSD4Eh94' }
    ]
  
})

export class LoginModule {}
